import { useCallback, useEffect, useState } from 'react';
import { getTeams } from '../api/teams';
import { Team } from '../types';


export const useGroups = (
  page: number,
  limit: number,
  name: string = '',
  onErrorCallback?: (error: any) => void
) => {
  const [groups, setGroups] = useState<Team[]>([]);

  const fetchTeams = useCallback(async () => {
    const { data, error } = await getTeams(page, limit, { name });

    if (error) {
      if (onErrorCallback) {
        onErrorCallback?.(error);
      }

      return;
    }

    if (data) {
      setGroups(data.teams);
    }
  }, [limit, name, onErrorCallback, page]);

  useEffect(() => {
    fetchTeams();
  }, [fetchTeams]);

  return { groups };
};
